import type { Device, fragQuery } from '@models';
import { isFiniteNumber } from '@lib/number';

export const REDUCTION_RATIO_PERCENT = 80;

export interface D80ReductionRatio {
    upstreamDevice: Device;
    downstreamDevice: Device;
    upstreamD80: number;
    downstreamD80: number;
    ratio: number;
}

export interface ReductionRatioState {
    loading: boolean;
    connectedDownstreamDeviceIds: ReadonlySet<number>;
    ratiosByDownstreamDeviceId: ReadonlyMap<number, D80ReductionRatio>;
}

export function getAggregateDValue(
    response: fragQuery.timeline.sieveSizesAtPercents.Response | null | undefined,
    percent: number,
): number | null {
    const value = response?.summary?.dvalues?.[percent];
    return isFiniteNumber(value) && value > 0 ? value : null;
}

export function createD80ReductionRatio(
    upstreamDevice: Device,
    downstreamDevice: Device,
    upstreamD80: number | null,
    downstreamD80: number | null,
): D80ReductionRatio | null {
    if (upstreamD80 == null || downstreamD80 == null || !isFiniteNumber(upstreamD80) || !isFiniteNumber(downstreamD80) || upstreamD80 <= 0 || downstreamD80 <= 0) {
        return null;
    }

    const ratio = upstreamD80 / downstreamD80;
    if (!isFiniteNumber(ratio) || ratio <= 0) {
        return null;
    }

    return {
        upstreamDevice,
        downstreamDevice,
        upstreamD80,
        downstreamD80,
        ratio,
    };
}
